<div class="app-dialog dc-share">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "digitalCards.sources.shareModalTitle" | translate }}</h2>
      @if (sourceName) {
        <p class="app-dialog__subtitle">{{ sourceName }}</p>
      }
    </div>
    <button
      type="button"
      mat-icon-button
      (click)="close()"
      [attr.aria-label]="'digitalCard.owner.closeModal' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <section class="app-dialog__section">
      <div class="dc-share__rows">
        <button
          type="button"
          class="dc-share__row"
          [class.dc-share__row--active]="mode === 'single'"
          (click)="setMode('single')"
        >
          <span class="dc-share__row-icon"><mat-icon>person</mat-icon></span>
          <span class="dc-share__row-label">{{
            "digitalCards.sources.shareModeSingle" | translate
          }}</span>
        </button>
        <button
          type="button"
          class="dc-share__row"
          [class.dc-share__row--active]="mode === 'bulk'"
          (click)="setMode('bulk')"
        >
          <span class="dc-share__row-icon"><mat-icon>groups</mat-icon></span>
          <span class="dc-share__row-label">{{
            "digitalCards.sources.shareModeBulk" | translate
          }}</span>
        </button>
      </div>
    </section>

    @if (mode === "single") {
      <section
        class="app-dialog__section"
        [hidden]="!showEmployeePicker"
      >
        <app-digital-card-employee-picker
          [value]="previewEmployee"
          (valueChange)="onEmployeeChange($event)"
          (initialSelectionResolved)="onEmployeePickerInitialResolved()"
        ></app-digital-card-employee-picker>
      </section>
    }

    @if (showLoading) {
      <div class="dc-share__loading">
        <app-loading [text]="'digitalCard.owner.loading' | translate"></app-loading>
      </div>
    } @else if (errorKey) {
      <section class="app-dialog__section">
        <div class="dc-share__rows">
          <button type="button" class="dc-share__row" (click)="retry()">
            <span class="dc-share__row-icon"><mat-icon>refresh</mat-icon></span>
            <span class="dc-share__row-label">{{ errorKey | translate }}</span>
          </button>
        </div>
      </section>
    } @else if (mode === "single" && ready && noPublishedCard) {
      <section class="app-dialog__section">
        <p class="dc-share__hint">
          {{ "digitalCards.sources.noPublishedCard" | translate }}
        </p>
      </section>
    } @else if (mode === "single" && ready && sourceUrl) {
      <section class="app-dialog__section">
        <header class="app-dialog__section-head">
          <h3>{{ "digitalCard.owner.shareQrTitle" | translate }}</h3>
        </header>
        @if (sourceUrl) {
          <div class="dc-share__qr" [style.--dc-share-qr-preview.px]="qrPreviewPx">
            <qrcode
              [qrdata]="sourceUrl"
              [width]="qrSvgPx"
              [errorCorrectionLevel]="shareQr.errorCorrectionLevel"
              [margin]="shareQr.margin"
              [colorDark]="shareQr.colorDark"
              [colorLight]="shareQr.colorLight"
              [elementType]="'svg'"
              (qrCodeURL)="qrSvgDownloadLink = $event"
            ></qrcode>
          </div>
          <div class="dc-share__qr-export" aria-hidden="true">
            <qrcode
              [qrdata]="sourceUrl"
              [width]="qrPngPx"
              [errorCorrectionLevel]="shareQr.errorCorrectionLevel"
              [margin]="shareQr.margin"
              [colorDark]="shareQr.colorDark"
              [colorLight]="shareQr.colorLight"
              [elementType]="'canvas'"
              (qrCodeURL)="qrPngDownloadLink = $event"
            ></qrcode>
          </div>
          <div class="dc-share__qr-actions">
            <button
              type="button"
              mat-stroked-button
              class="dc-share__qr-download"
              [disabled]="!qrSvgDownloadLink"
              (click)="downloadQrSvg()"
            >
              <mat-icon>download</mat-icon>
              {{ "digitalCard.owner.downloadQrSvgButton" | translate }}
            </button>
            <button
              type="button"
              mat-stroked-button
              class="dc-share__qr-download"
              [disabled]="!qrPngDownloadLink"
              (click)="downloadQrPng()"
            >
              <mat-icon>download</mat-icon>
              {{ "digitalCard.owner.downloadQrPngButton" | translate }}
            </button>
          </div>
          <a
            #downloadQrSvgRef
            [href]="qrSvgDownloadLink"
            [download]="qrFileBase + '.svg'"
            class="dc-share__hidden-anchor"
          ></a>
          <a
            #downloadQrPngRef
            [href]="qrPngDownloadLink"
            [download]="qrFileBase + '.png'"
            class="dc-share__hidden-anchor"
          ></a>
        }
      </section>

      <section class="app-dialog__section">
        <header class="app-dialog__section-head">
          <h3>{{ "digitalCard.owner.shareCopyTitle" | translate }}</h3>
        </header>
        <div class="dc-share__rows">
          <button type="button" class="dc-share__row" (click)="copyLink()">
            <span class="dc-share__row-icon"><mat-icon>link</mat-icon></span>
            <span class="dc-share__row-label">{{
              "digitalCard.owner.copyLink" | translate
            }}</span>
          </button>
        </div>
      </section>
    } @else if (mode === "bulk" && ready) {
      <section class="app-dialog__section">
        <div class="dc-share__rows">
          <button type="button" class="dc-share__row" (click)="downloadCsv()">
            <span class="dc-share__row-icon"><mat-icon>download</mat-icon></span>
            <span class="dc-share__row-label">{{
              "digitalCards.sources.bulkDownloadCsv" | translate
            }}</span>
          </button>
        </div>
      </section>
    }
  </div>
</div>
